import { combineReducers } from 'redux';
import cardSearchReducer from './cardSearchReducer';
import sessionReducer from './sessionReducer';

export default combineReducers({
	cardSearch: cardSearchReducer,
	session: sessionReducer
});
